import { useEffect } from "react";

const FOCUSABLE_SELECTOR = "a[href], button, input, select, textarea, iframe";

// react-slick marks the slides that are not visible (including the cloned ones) with aria-hidden
// and forces tabindex="-1" on the children of every slide, whatever its state. Links and buttons
// in a hidden slide must be out of the tab order, and the ones in a visible slide must be in it.
const syncSlideTabOrder = (slider) => {
  slider.querySelectorAll(".slick-slide").forEach((slide) => {
    const hidden = slide.getAttribute("aria-hidden") === "true";

    slide.querySelectorAll(FOCUSABLE_SELECTOR).forEach((element) => {
      if (hidden && element.getAttribute("tabindex") !== "-1") {
        element.setAttribute("tabindex", "-1");
      } else if (!hidden && element.getAttribute("tabindex") === "-1") {
        element.removeAttribute("tabindex");
      }
    });
  });
};

// Keeps the tab order of a react-slick slider in sync with the slides that are visible.
// Pass a ref to the Slider and a value that changes when its content changes.
const useSlickTabOrder = (sliderRef, content) => {
  useEffect(() => {
    const list =
      sliderRef.current &&
      sliderRef.current.innerSlider &&
      sliderRef.current.innerSlider.list;
    const slider = list && list.closest(".slick-slider");

    if (!slider) return undefined;

    syncSlideTabOrder(slider);

    const observer = new MutationObserver(() => syncSlideTabOrder(slider));
    observer.observe(slider, {
      subtree: true,
      childList: true,
      attributes: true,
      attributeFilter: ["aria-hidden"],
    });

    return () => observer.disconnect();
  }, [sliderRef, content]);
};

export default useSlickTabOrder;
